<mat-form-field color="accent" style="min-width: 100%!important; max-width: 100%!important; width: 100%!important;">  
    <mat-label>{{placeholder}}
    </mat-label>    
    <mat-button *ngIf="showClearButton" (click)="clearStartDate($event)" title="Reset date">      
      <mat-icon matDatepickerToggleIcon style="font-size:12px">        
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
      </mat-icon>
    </mat-button>
  
  <input matInput [matDatepicker]="dp" 
        [required]="required"
        [disabled]="disabled" 
        [readonly]="readonly" 
        [min]="min" 
        [customMinDate]="min"
        [max]="max" 
        [customMaxDate]="max"
        [(ngModel)]="_value" 
        (dateInput)="dateInputChange($event)" 
        (dateChange)="calendarInputChange($event)"
        (keyup)="dateInputChange(null)"
        #dateInputControl="ngModel"
        style="min-width: 100%!important; max-width: 100%!important; width: 100%!important;">
    <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>      
    <mat-datepicker #dp [startAt]="startAt"></mat-datepicker>
    <validation-errors [min]='min' [max]='max'></validation-errors>
</mat-form-field>
  